// extracted by mini-css-extract-plugin
export default {"companyContainer":"vU-z","companyImage":"wU-z","container":"xU-z","heading":"yU-z","darkText":"zU-z","smallHeading":"AU-z","darkBackground":"BU-z","whiteBackground":"CU-z"};